<template>
  <div class="loading" v-if="loading">
    <img src="../assets/loading.gif" />
  </div>
  <div :class="[loading ? 'l-modal__bg' : '']"></div>

  <div v-if="detail.id > -1" class="project-detail">
    <header class="header">
      <div
        v-if="detail.banner && setButton().button != '応募済' && !isEntryEnd"
      >
        <div class="warnig-banner" @click="push()">
          <img
            class="detail_icon"
            src="../assets/information.svg"
            align="left"
          />
          <p class="warnig-banner-message">{{ detail.banner.message }}</p>
          <img class="detail_icon" src="../assets/detail.svg" align="right" />
        </div>
      </div>
    </header>
    <div class="project-detail-content1">
      <div class="project-detail-content1-img-area">
        <img
          class="project-detail-content1-img"
          :src="detail.image"
          alt="案件画像"
          loading="lazy"
          :style="isEntryEnd ? 'filter: brightness(0.7);' : ''"
        />
        <!--お気に入りicon-->
        <div class="favorite" @click.stop="updateFavorite()">
          <img
            src="../assets/favorite-icon.svg"
            :class="[
              addUpdateFavorite && detail.is_favorited
                ? 'update-favorite-icon'
                : detail.is_favorited
                ? 'favorite-icon'
                : '',
            ]"
          />
        </div>
        <!-- <p v-if="isEntryEnd">募集終了</p> -->
      </div>

      <p class="project-detail-content1-title pt-21">{{ detail.title }}</p>
      <p class="project-detail-content1-title pt-15 pb-12" v-if="!detail.is_offer">
        ￥{{ detail.outsourcing_amount.toLocaleString() }}
      </p>
      <p v-else class="project-detail-content1-title pt-15 pb-12" >応相談</p>
      <div class="project-detail-content1-condition pb-5">
        <img :src="setMediaIcon(detail.media_type)" />
        <span>{{ setMediaName(detail.media_type) }}</span>
        <img src="../assets/person.svg" /><span
          >{{ detail.min_follower_count.toLocaleString() }}登録者以上</span
        >
      </div>
      <div class="project-detail-content1-condition">
        <img src="../assets/capacity.svg" /><span
          >{{ detail.recruitment_numbers }}名様</span
        >
      </div>
      <div class="project-detail-content1-condition2 pt-15">
        募集期間： {{ setDiaplayDate(detail.entry_started_at, false) }} 〜
        {{ setDiaplayDate(detail.entry_ended_at, true) }}
      </div>
    </div>
    <div class="project-detail-divider"></div>
    <div class="project-detail-sub-header" v-show="detail.products.length">
      <p>商品概要</p>
    </div>
    <!-- 商品が複数になる場合あり -->
    <div
      class="project-detail-content2"
      v-for="(product, index) in detail.products"
      :key="index"
    >
      <p class="p__style__4 pt-25" style="color: #a3a3a3">
        {{ product.brand_name }}
      </p>
      <p class="p__style__4 pt-3">{{ product.name }}</p>
      <p
        :class="[
          detail.aplication_state != APPLICATION_STATE.CANNOT_APPLY &&
          detail.aplication_state >= APPLICATION_STATE.APPLIED
            ? 'applied'
            : '',
        ]"
        class="p__style__4 pt-17"
      >
        {{ product.description }}
      </p>
      <common-button
        :data="{
          status: 1,
          button: `商品詳細`,
        }"
        @click="linkTo(product.url)"
        style="margin-top: 30px"
        v-show="product.url"
      ></common-button>
    </div>
    <div class="project-detail-divider"></div>
    <div class="project-detail-sub-header"><p>案件概要</p></div>
    <div class="project-detail-content3">
      <ul>
        <li type="none" class="pt-30"><span>訴求内容</span></li>
        <p class="p__style__4 pb-50 pt-20">
          {{ detail.description }}
        </p>
        <div class="project-detail-content3-ng">
          <li type="none"><span>NG事項</span></li>
          <ul class="ng-list">
            <li
              type="disc"
              v-for="(item, index) in detail.prohibitions"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <li type="none">注意事項</li>
        <p class="p__style__4 pt-22 pb-20">
          {{ detail.note }}
        </p>
        <common-button
          :data="{
            status: 1,
            button: `詳細資料`,
          }"
          @click="linkTo(detail.orientation_url)"
          style="margin-bottom: 20px"
          v-show="detail.orientation_url"
        ></common-button>
        <li type="disc" style="margin-bottom: 14px" v-if="detail.hashtag">ハッシュタグ</li>
        <div
          class="project-detail-content3-hash-tags p__style__3"
          v-for="(hashTag, index) in splitHashTag(detail.hashtag)"
          :key="index"
        >
          #{{ hashTag }}
        </div>
        <common-button
          :data="{
            status: 3,
            button: `ハッシュタグをコピーする`,
          }"
          @click="copyHashTag()"
          style="margin-top: 20px"
          v-if="
            detail.aplication_state != APPLICATION_STATE.CANNOT_APPLY &&
            detail.aplication_state >= APPLICATION_STATE.WON && detail.hashtag
          "
        ></common-button>
      </ul>
    </div>
    <div class="project-detail-content4 mt-50">
      <p class="project-detail-content4-title">依頼主</p>
      <p class="p__style__4">{{ detail.client.name }}</p>
      <p class="project-detail-content4-title">募集期間</p>
      <p class="p__style__4">
        {{ setDiaplayDate(detail.entry_started_at,false) }} 〜
        {{ setDiaplayDate(detail.entry_ended_at,true) }}
      </p>
      <p class="project-detail-content4-title">投稿期間</p>
      <p class="p__style__4">
        {{ setDiaplayDate(detail.post_started_at,false) }} 〜
        {{ setDiaplayDate(detail.post_ended_at,false) }}
      </p>
      <!-- <p class="project-detail-content4-title">投稿確認期限</p>
      <p class="p__style__4">{{ detail.confirm_deadline }}</p> -->
      <p class="project-detail-content4-title">募集メディア</p>
      <p class="p__style__4">{{ setMediaName(detail.media_type) }}</p>
      <p class="project-detail-content4-title">エントリー条件</p>
      <p class="p__style__4">
        {{ detail.min_follower_count.toLocaleString() }}登録者以上
      </p>
      <p class="project-detail-content4-title">募集人数</p>
      <p class="p__style__4">
        {{ detail.recruitment_numbers.toLocaleString() }}名
      </p>
      <p class="project-detail-content4-title">お支払い金額</p>
      <p class="p__style__4" v-if="!detail.is_offer">
        ¥{{ detail.outsourcing_amount.toLocaleString() }} (税別)
      </p>
      <p class="p__style__4" v-else>
        応相談
      </p>
      <!-- <p class="project-detail-content4-title">お支払い期日</p>
      <p class="p__style__4">{{ detail.payment_due_date }}</p> -->
      <br />
    </div>
    <div class="contact">
      <common-button
        :data="{
          status: 3,
          button: `お問い合わせ`,
        }"
        @click="openContactDialog()"
        v-if="!isEntryEnd"
      ></common-button>
    </div>
    <div class="footer">
      <common-button :data="setButton()" @click="confirm()"></common-button>
    </div>
    <comfirm-dialog
      ref="dialog"
      v-model="showDialog"
      :message="message"
      :button="button"
      @apply="applyProject()"
    ></comfirm-dialog>
  </div>
  <!-- お問い合わせボタンは募集期間中のみ表示する -->
  <contact-dialog
    ref="contactDialog"
    v-model="showContactDialog"
    :projectId="detail.id"
  ></contact-dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import ComfirmDialog from "./ComfirmDialog.vue";
import CommonButton from "./CommonButton.vue";
import ContactDialog from "./ContactDialog.vue";
import { CommonStore } from "../store/CommonStore";
import { UserInfoStore } from "../store/UserInfoStore";

import { useRoute } from "vue-router";
import router from "../router";

import {
  APPLICATION_STATE,
  BUTTON_NAME,
  MEDIA_ICON,
  MEDIA_NAME,
} from "../consts/common";
import { ProjectStore } from "../store/ProjectStore";
import { projectDetail } from "../types/apiResponse";
import dayjs from "dayjs";
const commonStore = CommonStore();

const dialog = ref<InstanceType<typeof ComfirmDialog>>();
const contactDialog = ref<InstanceType<typeof ContactDialog>>();
const projectStore = ProjectStore();
const loading = ref(false);
const message = ref("");
const userInfoStore = UserInfoStore();

const showDialog = ref(false);
const showContactDialog = ref(false);
const button = ref("");
const isEntryEnd = ref(false);
const addUpdateFavorite = ref(false);
const detail = ref<projectDetail>({
  aplication_state: 0,
  banner: {
    message: "案件に応募するためにはプロフィール登録が必要です",
    target: "sign-up",
  },
  client: {
    id: 0,
    name: "",
  },
  confirm_deadline: "",
  description: "",
  draft: null,
  document_url: "",
  entry_ended_at: "",
  entry_started_at: "",
  has_shipment: false,
  hashtag: "",
  id: -1,
  image: "",
  is_favorited: false,
  is_needed_review: false,
  is_offer: false,
  link_url: "",
  media_type: 0,
  min_follower_count: 0,
  note: "",
  orientation_url: "",
  outsourcing_amount: 0,
  payment_due_date: "投稿月の翌月末",
  post_ended_at: "",
  post_started_at: "",
  products: [
    {
      brand_name: "",
      brand_name_kana: "",
      description: "",
      id: 0,
      manufacturer_name: "",
      name: "",
      url: "",
    },
  ],
  prohibitions: [],
  recruitment_numbers: 0,
  state: 0,
  title: "",
});

const setMediaIcon = (media_type: number) => {
  return MEDIA_ICON[media_type];
};
const setMediaName = (media_type: number) => {
  return MEDIA_NAME[media_type];
};
// 日付をYYYY年MM月DD日にフォーマットして返す
const setDiaplayDate = (date: string, isEndDate: boolean) => {
  // 募集終了期間は管理画面で00:00に設定されているため-1日表示する
  if (isEndDate) {
    const enddate = new Date(date)
    enddate.setDate(enddate.getDate() - 1)
    return dayjs(new Date(enddate)).format("YYYY年MM月DD日");
  } 
  return dayjs(new Date(date)).format("YYYY年MM月DD日");
};
// 応募する 応募済 キャンセル済 応募不可
function setButton() {
  if (detail.value.id == -1) return { status: 0, button: "" };
  if (isEntryEnd.value) {
    return {
      status: 2,
      button: "募集終了",
    };
  }
  const result = BUTTON_NAME.get(detail.value.aplication_state);
  if (!result) {
    return {
      status: 2,
      button: "応募済",
    };
  }

  return BUTTON_NAME.get(detail.value.aplication_state);
}

// 確認ダイアログを表示する
const confirm = () => {
  if (isEntryEnd.value) return;
  // ユーザー応募ステータスが応募前もしくはキャンセル済以外はボタンが押せないようにする
  if (
    detail.value.aplication_state == APPLICATION_STATE.BEFORE_APPLY ||
    detail.value.aplication_state == APPLICATION_STATE.CANCELED
  ) {
    if (
      detail.value.aplication_state == APPLICATION_STATE.BEFORE_APPLY &&
      dialog.value
    ) {
      showDialog.value = true;
      message.value = "この案件への応募しますか?";
      button.value = "応募する";
      dialog.value.openDialog();
    } else if (detail.value.aplication_state == APPLICATION_STATE.CANCELED) {
      showDialog.value = true;
      message.value = "この案件への再応募しますか?";
      button.value = "再応募する";
      dialog.value?.openDialog();
    }
  }
};

function copyHashTag() {
  navigator.clipboard.writeText(detail.value.hashtag);
  commonStore.setToast({
    showToast: true,
    message: "ハッシュタグをコピーしました",
    state: 0,
    timeout: 2000,
  });
}

function openContactDialog() {
  showContactDialog.value = true;
  contactDialog.value?.openContactDialog();
}

const splitHashTag = (hashTag: string) => {
  const hashTags = hashTag.replaceAll("＃", "#").trim().split("#");
  // 空白は削除
  return hashTags.filter(Boolean);
};
// 案件応募
const applyProject = async () => {
  loading.value = true;
  const res = await projectStore.applyProject();
  if (res) {
    detail.value.aplication_state = APPLICATION_STATE.APPLIED;
  }
  loading.value = false;
};

// お気に入り追加解除
async function updateFavorite() {
  if (detail.value.is_favorited) {
    const result = await projectStore.deleteFavoriteProject(detail.value.id);
    if (result) {
      detail.value.is_favorited = false;
      projectStore.updateActiveProject(
        detail.value,
        commonStore._mediaId,
        false
      );
      addUpdateFavorite.value = false;
    }
  } else {
    const result = await projectStore.addFavoriteProject(detail.value);
    if (result) {
      detail.value.is_favorited = true;
      projectStore.updateActiveProject(
        detail.value,
        commonStore._mediaId,
        true
      );
      addUpdateFavorite.value = true;
    }
  }
}

function push() {
  userInfoStore.setIsRegistFromProjectDetail({
    show: true,
    title: detail.value.title,
    mediaType: detail.value.media_type,
  });
  // ユーザー未登録であれば、ユーザー登録→銀行口座登録→SNS登録→住所登録
  // 銀行口座未登録であれば、銀行口座登録→SNS登録？（未登録であれば）→住所登録（未登録であれば）
  // SNS未登録であればSNS登録→住所登録（未登録であれば）
  // SNS未登録であればSNS登録画面に遷移、ユーザー登録情報が不足していればユーザー情報更新画面に遷移
  // 住所未登録であれば住所登録
  router.replace("/" + detail.value.banner.target);
}

const state = ref(0);
const route = useRoute();

/** リンク */
const linkTo = (link: string) => {
  // window.location.href = link
  window.open(link);
};
onMounted(async () => {
  // 応募前案件か応募中案件か
  state.value = +(route.query.state || 0);
  loading.value = true;
  // 案件詳細API
  const res = await projectStore.getProjectDetail();
  if (!res) {
    setTimeout(() => {
      commonStore.setToast({
        showToast: true,
        message: "読み込みに失敗しました",
        state: 1,
        timeout: 2000,
      });

      setTimeout(() => {
        router.back();
      }, 3000);
    }, 1000);
  } else {
    detail.value = res;
    document.title = res.title;
    // 管理画面に入力されている募集日時が00:00で入力されているため表示する日付を-1する
    if ((Math.floor((new Date(detail.value.entry_ended_at).getTime() - (new Date(new Date().toDateString())).getTime()) / (24 * 60 * 60 * 1000))) -1 < 0) {
      isEntryEnd.value = true;
    }
    loading.value = false;
  }
});
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
@mixin p__defalut($size, $line_height) {
  font-style: normal;
  font-weight: 300;
  font-size: $size;
  line-height: $line_height;
  color: #333333;
  margin: 0;
  white-space: pre-line;
}
html {
  overscroll-behavior: none;
}
.project-detail {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;
  background-color: $white;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  color: #333333;
  .toast {
    @include toast();
  }

  .project-detail-content1 {
    text-align: center;
    .project-detail-content1-img-area {
      position: relative;
      width: 100%;
      p {
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        color: $white;
        font-size: 1.8rem;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    .project-detail-content1-img {
      position: relative;
      width: 100%;
    }
    .favorite {
      position: absolute;
      display: flex;
      bottom: 20px;
      right: 13px;
      width: 40px;
      height: 40px;
      text-align: center;
      align-items: center;
      border-radius: 50%;
      background-color: $white;
      img {
        width: 18px;
        height: 15px;
        margin: auto;
      }
      .favorite-icon {
        filter: brightness(0) saturate(100%) invert(51%) sepia(19%)
          saturate(1564%) hue-rotate(162deg) brightness(92%) contrast(87%);
      }
      .update-favorite-icon {
        filter: brightness(0) saturate(100%) invert(51%) sepia(19%)
          saturate(1564%) hue-rotate(162deg) brightness(92%) contrast(87%);
        transform-origin: center bottom;
        animation: bounce 0.8s linear 0s 1;
      }
    }
    @keyframes bounce {
      0% {
        transform: scale(1, 1) translate(0%, 0%);
      }
      15% {
        transform: scale(0.9, 0.9) translate(0%, 5%);
      }
      30% {
        transform: scale(1.3, 0.8) translate(0%, 10%);
      }
      50% {
        transform: scale(0.8, 1.3) translate(0%, -10%);
      }
      70% {
        transform: scale(1.1, 0.9) translate(0%, 5%);
      }
      100% {
        transform: scale(1, 1) translate(0%, 0%);
      }
    }

    p {
      text-align: left;
    }
    .project-detail-content1-title {
      text-align: left;
      font-style: normal;
      font-weight: 600;
      font-size: $FONT_SIZE_XL;
      line-height: 27px;
      margin: 0 16px;
      color: #030403;
    }

    .project-detail-content1-condition {
      display: flex;
      align-items: center;
      margin: 0 16px;
      img {
        @include img(16px, 8px);
      }
      span {
        margin-right: 6px;
      }
    }
    .project-detail-content1-condition2 {
      text-align: left;
      margin: 0 16px;
    }
  }
  .project-detail-divider {
    width: 100%;
    height: 10px;
    background: #f8f8f8;
    margin-top: 30px;
  }
  .project-detail-sub-header {
    border-left: 2px solid #086eb6;
    height: 40px;
    line-height: 40px;
    margin-left: 25px;
    p {
      @include p__defalut($FONT_SIZE_L, 40px);
      font-weight: 600;
      margin: 29px 16px 0 10px;
    }
  }
  .project-detail-content2 {
    margin: 0 30px;
    .applied {
      overflow-y: hidden;
      height: 70px;
      line-height: 18px;
      @include line-clamp(4);
    }
  }
  .project-detail-content3 {
    ul {
      padding-left: 0;
    }
    ul li {
      list-style: none;
      font-weight: 600;
      font-size: $FONT_SIZE_M;
      padding-bottom: 10px;
      color: $OMOT_COLOR;
      border-bottom: 0.5mm dotted #0d68aa;
    }

    .project-detail-content3-ng {
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      background: #fbfbfd;
      padding: 25px 14px 30px 20px;
      margin-bottom: 50px;
      ul {
        padding-left: 20px;
        padding-right: 19px;
        li {
          list-style: disc;
          border-bottom: none;
          color: #333333;
          padding-bottom: 0;
        }
      }
    }
    margin: 0 30px;
    .project-detail-content3-hash-tags {
      display: inline-flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      margin-right: 6px;
      margin-bottom: 6px;
      width: fit-content;
      height: 33px;

      background: $white;
      border: 1px solid #d6d3cf;
      border-radius: 90px;
    }
  }
  .project-detail-content4 {
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
    background: #fbfbfb;
    border-radius: 5px;
    margin-right: 20px;
    margin-left: 20px;
    .project-detail-content4-title {
      margin-bottom: 0;
      padding-left: 15px;
      font-style: normal;
      font-weight: 600;
      font-size: $FONT_SIZE_M;
      line-height: 21px;
    }
    p {
      margin-left: 15px;
      padding-right: 15px;
    }
    p:nth-child(even) {
      padding-bottom: 13px;
      padding-left: 13px;
      padding-top: 10px;
      margin-right: 15px;
      border-bottom: 1px dashed #e1e1e1;
    }
  }
  .footer {
    width: 100%;
    max-width: 480px;
    text-align: center;
    position: fixed;
    bottom: 80px;
    margin: 0 auto;
  }
}

.project-detail::-webkit-scrollbar {
  display: none;
}
ul {
  padding: 16px 0;
}
hr {
  height: 0px;
  margin: 0 16px;
  border: 1px solid #ececec;
}

.p__style__3 {
  @include p__defalut($FONT_SIZE_S, 18px);
}
.p__style__4 {
  @include p__defalut($FONT_SIZE_M, 21px);
}

.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 50%;
  z-index: 9999;
  img {
    width: 10%;
    height: 10%;
  }
}
.header {
 position: sticky;
 top: 0;
 z-index: 99;
}
.warnig-banner {
  max-width: 480px;
  // position: fixed;
  // top: 0;
  z-index: 99;
  width: 100%;
  border-radius: 2px;
  align-content: center;
  background-color: rgba(254, 250, 231, 1);
  min-height: 60px;
  display: flex;
  padding: auto 20px;
  align-items: center;
  .warnig-banner-message {
    width: calc(100% - 70px);
    color: rgba(77, 76, 73, 1);
    font-weight: 300 !important;
    font-size: $FONT_SIZE_M !important;
    line-height: 21px;
    padding: 0 30px;
  }
  img:nth-child(1) {
    text-align: left;
    padding-left: 20px;
  }
  img:nth-last-child(1) {
    text-align: right;
    padding-right: 15px;
    filter: brightness(0) saturate(100%) invert(29%) sepia(2%) saturate(1053%)
      hue-rotate(53deg) brightness(93%) contrast(88%);
  }
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(89, 89, 89, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
.contact {
  padding: 20px 0 150px 0;
  margin: 0 30px;
}
</style>
